import intl from "react-intl-universal";
import { DescriptionText, SectionContent } from "../../styled";
import { MaterialBadgesRow } from "./styled";

export interface ReplacementMaterialDecisionDto {
  OriginalMaterialId?: number;
  MaterialId?: number;
  Description?: string;
}

interface ReplacementMaterialDecisionProps {
  replacementMaterialDecision?: ReplacementMaterialDecisionDto | null;
}

const ReplacementMaterialDecision = (props: ReplacementMaterialDecisionProps) => {
  const { replacementMaterialDecision } = props;

  if (!replacementMaterialDecision) return null;

  const { OriginalMaterialId, MaterialId, Description } = replacementMaterialDecision;

  return (
    <SectionContent>
      <DescriptionText $fontWeight={700} $fontSize="0.75rem">
        {intl.get("stocks.suggestionContext.replacementMaterialDecision.title")}
      </DescriptionText>

      <MaterialBadgesRow>
        <DescriptionText $fontWeight={700} >
          {intl.get("stocks.suggestionContext.replacementMaterialDecision.original")}:
        </DescriptionText>
        <DescriptionText>
          {OriginalMaterialId}
        </DescriptionText>

        <DescriptionText $fontWeight={700} >
          {intl.get("stocks.suggestionContext.replacementMaterialDecision.suggested")}:
        </DescriptionText>
        <DescriptionText>
          {MaterialId}
        </DescriptionText>


      </MaterialBadgesRow>

      {Description && <DescriptionText>{Description}</DescriptionText>}
    </SectionContent>
  );
};

export default ReplacementMaterialDecision;
